import React, { Component } from "react";
import { I18n } from "react-i18next";
import "../utils/i18n";
import "./Recherche.css";
import FilterGroup from "./FilterGroup";
import Menu from "../app-header/Menu";
import api from "../api/api";
import RechercheResult from "./RechercheResult";

const LIMIT = 500;

const initialState = {
  massnahmen: [],
  filterIsOpen: {
    kanton: false,
    datum: false,
    ort: false,
    massnahme: false,
    orgelbauer: false
  },
  search: {
    kantone: ["lu", "nw", "ow", "so", "ti", "ur", "zg", "sz"],
    massnahmenIncluded:
      "Neubau,Construction,Costruzione,Rekonstruktion,Réconstruction,Ricostruzione,Restaurierung,Restauration,Restauro",
    massnahmenExcluded:
      "Vorschlag,Voranschlag,Offerte,Projekt,Proposition,Devis,Projet,Progetto,Preventivo",
    yearFrom: "",
    yearTo: "",
    ort: "",
    orgelbauer: ""
  }
};

const kantone = ["lu", "nw", "ow", "so", "ti", "ur", "zg", "sz"];

class Recherche extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleKantonCheckbox = this.toggleKantonCheckbox.bind(this);
    this.toggleFilterOpen = this.toggleFilterOpen.bind(this);
  }
  componentDidMount() {
    const persistedRechercheState = sessionStorage.getItem("rechercheState");
    if (persistedRechercheState) {
      this.setState(JSON.parse(persistedRechercheState), () => {});
    }
  }
  componentWillUnmount() {
    sessionStorage.setItem("rechercheState", JSON.stringify(this.state));
    if (this.search$ !== undefined) {
      this.search$ = this.search$.unsubscribe();
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    this.search$ = api
      .fetchRecherche(
        this.state.search.yearFrom,
        this.state.search.yearTo,
        this.state.search.kantone.join(","),
        this.state.search.ort,
        this.state.search.orgelbauer,
        this.state.search.massnahmenIncluded,
        this.state.search.massnahmenExcluded
      )
      .subscribe(result => {
        this.setState({ massnahmen: result.massnahmen });
        sessionStorage.setItem("rechercheState", JSON.stringify(this.state));
      });
  }
  toggleKantonCheckbox(e) {
    let index = this.state.search.kantone.indexOf(e.target.value);
    let kantone = this.state.search.kantone;
    index >= 0 ? kantone.splice(index, 1) : kantone.push(e.target.value);
    this.setState({ kantone: kantone });
  }
  handleChange(e) {
    let search = { ...this.state.search };
    search[e.target.name] = e.target.value;
    this.setState({ search: search });
  }
  toggleFilterOpen(e) {
    let filterIsOpen = this.state.filterIsOpen;
    filterIsOpen[e.target.id] = !this.state.filterIsOpen[e.target.id];
    this.setState({ filterIsOpen: filterIsOpen });
  }

  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <Menu />
            <div className="row">
              <form onSubmit={this.handleSubmit}>
                <div className="span4">
                  <div className="recherche-suche recherche-suchfeld">
                    <input
                      type="submit"
                      name="submit"
                      value={t("recherche.suchen")}
                      onClick={this.handleSubmit}
                    />
                  </div>
                  <FilterGroup
                    id="kanton"
                    title={t("detail.Kanton")}
                    toggleHidden={this.toggleFilterOpen}
                    isOpen={this.state.filterIsOpen.kanton}
                  >
                    {kantone.map((key, index) => (
                      <label className="recherche-label checkbox" key={key}>
                        <input
                          value={key}
                          type="checkbox"
                          onChange={this.toggleKantonCheckbox}
                          checked={this.state.search.kantone.indexOf(key) >= 0}
                        />
                        {t("recherche.Kantone." + key)}
                      </label>
                    ))}
                  </FilterGroup>
                  <FilterGroup
                    id="ort"
                    title={t("detail.Ort")}
                    toggleHidden={this.toggleFilterOpen}
                    isOpen={this.state.filterIsOpen.ort}
                  >
                    <label className="recherche-label">
                      {t("detail.Ort")}:<br />
                      <input
                        value={this.state.search.ort}
                        name="ort"
                        onChange={this.handleChange}
                      />
                    </label>
                  </FilterGroup>
                  <FilterGroup
                    id="datum"
                    title={t("detail.Datum")}
                    toggleHidden={this.toggleFilterOpen}
                    isOpen={this.state.filterIsOpen.datum}
                  >
                    <label className="recherche-label">
                      {t("recherche.Datum.ab")}:<br />
                      <input
                        value={this.state.search.yearFrom}
                        name="yearFrom"
                        onChange={this.handleChange}
                      />
                    </label>
                    <label className="recherche-label">
                      {t("recherche.Datum.bis")}:<br />
                      <input
                        value={this.state.search.yearTo}
                        name="yearTo"
                        onChange={this.handleChange}
                      />
                    </label>
                  </FilterGroup>
                  <FilterGroup
                    id="massnahme"
                    title={t("detail.Massnahme")}
                    toggleHidden={this.toggleFilterOpen}
                    isOpen={this.state.filterIsOpen.massnahme}
                  >
                    {t("recherche.Massnahme.included")}:
                    <textarea
                      rows="4"
                      value={this.state.search.massnahmenIncluded}
                      name="massnahmenIncluded"
                      onChange={this.handleChange}
                    />
                    {t("recherche.Massnahme.excluded")}:
                    <textarea
                      rows="4"
                      value={this.state.search.massnahmenExcluded}
                      name="massnahmenExcluded"
                      onChange={this.handleChange}
                    />
                  </FilterGroup>
                  <FilterGroup
                    id="orgelbauer"
                    title={t("detail.OrgelbauerExperte")}
                    toggleHidden={this.toggleFilterOpen}
                    isOpen={this.state.filterIsOpen.orgelbauer}
                  >
                    <label className="recherche-label">
                      {t("detail.OrgelbauerExperte")}:<br />
                      <input
                        value={this.state.search.orgelbauer}
                        name="orgelbauer"
                        onChange={this.handleChange}
                      />
                    </label>
                  </FilterGroup>
                </div>
              </form>
              <div className="span8">
                <RechercheResult
                  massnahmen={this.state.massnahmen}
                  limit={LIMIT}
                />
              </div>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default Recherche;



// WEBPACK FOOTER //
// ./src/recherche/Recherche.js